import React, { FC } from 'react';
import { MOverlayCta } from '../MOverlayCta/index';
import { AImage } from '../../atoms/AImage/index';
import * as Styled from './MCtaThumbnail.styles';
import { MCtaThumbnailProps } from './MCtaThumbnail.types';

export const MCtaThumbnail: FC<MCtaThumbnailProps> = ({ mOverlayCta, aImage, className, ...rest }) => {
  return (
    <Styled.Wrapper className={className} {...rest}>
      <Styled.ImageWrapper>
        <AImage
          image={aImage.image}
          alt={aImage.alt}
          src={aImage.src}
          loading={aImage.loading || 'lazy'}
          renditions={aImage.renditions}
          title={aImage.title}
          imgClass={aImage.imgClass}
        />
      </Styled.ImageWrapper>
      <Styled.OverlayWrapper>
        <MOverlayCta mTextBlockSimple={mOverlayCta.mTextBlockSimple} mButton={mOverlayCta.mButton} />
      </Styled.OverlayWrapper>
    </Styled.Wrapper>
  );
};

export * from './MCtaThumbnail.types';
